export default __webpack_public_path__ + "static/media/bulb.05a0201d.svg";